import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";
import {postMiddlewareFile,getMiddlewareFile,updateMiddlewareFile,deleteMiddlewareFile } from "@/utils/apiMiddlewarePaths";

const api_endpoint_prefix = "layer_client";


class ClientService {
  storeAuthServer(AuthServerData) {
    const form_data = new FormData();
    for (var key in AuthServerData) {
      form_data.append(key, AuthServerData[key]);
    }
    return axiosInstance
    .post(postMiddlewareFile("authserver", api_endpoint_prefix), form_data, {
      headers: authHeader("authserver", api_endpoint_prefix),
    })
    .then((response) => {
      return response.data;
    });
  }

  getAuthserver(param) {
    let queryString = "";
    if (param.searchdata) {
      queryString = "?searchdata=" + param.searchdata;
    }
    return axiosInstance.get(getMiddlewareFile("authserver", api_endpoint_prefix) + queryString, {
      headers: authHeader("authserver", api_endpoint_prefix),
    });
  }

  updateAuthServer(AuthServerData) {
    const form = new FormData();
    form.append("id", AuthServerData.edit_id);
    form.append("name", AuthServerData.edit_name);
    form.append("ip", AuthServerData.edit_ip);
    form.append("company_name", AuthServerData.edit_company_name);
    form.append("status", AuthServerData.edit_status);
   return axiosInstance
      .post(updateMiddlewareFile("authserver", api_endpoint_prefix), form, {
        headers: authHeader("authserver", api_endpoint_prefix),
      })
      .then((response) => {
        return response.data;
      });
  }

  storeVpnServer(VpnserverData) {
    const form_data = new FormData();
    for (var key in VpnserverData) {
      form_data.append(key, VpnserverData[key]);
    }
    return axiosInstance
    .post(postMiddlewareFile("vpnserver", api_endpoint_prefix), form_data, {
      headers: authHeader("vpnserver", api_endpoint_prefix),
    })
    .then((response) => {
      return response.data;
    });
  }

  getVpnServer(param) {
    let queryString = "";
    if (param.searchdata) {
      queryString = "?searchdata=" + param.searchdata;
    }
    return axiosInstance.get(getMiddlewareFile("vpnserver", api_endpoint_prefix) + queryString, {
      headers: authHeader("vpnserver", api_endpoint_prefix),
    });
  }

  updateVpnServer(VpnServerData) {
    const form = new FormData();
    form.append("id", VpnServerData.edit_id);
    form.append("name", VpnServerData.edit_name);
    form.append("ip", VpnServerData.edit_ip);
    form.append("company_name", VpnServerData.edit_company_name);
    form.append("city", VpnServerData.edit_city);
    form.append("capacity", VpnServerData.edit_capacity);
    form.append("order_priority", VpnServerData.edit_order_priority);
    form.append("bandwidth_capacity", VpnServerData.edit_bandwidth_capacity);
    form.append("status", VpnServerData.edit_status);
    return axiosInstance
      .post(updateMiddlewareFile("vpnserver", api_endpoint_prefix), form, {
        headers: authHeader("vpnserver", api_endpoint_prefix),
      })
      .then((response) => {
        return response.data;
      });
  }

  deleteVpnServer(VpnServerData) {
    const form = new FormData();
    form.append("id", VpnServerData.edit_id);
    return axiosInstance
      .post(deleteMiddlewareFile("vpnserver", api_endpoint_prefix), form, {
        headers: authHeader("vpnserver", api_endpoint_prefix),
      })
      .then((response) => {
        return response.data;
      });
  }

  getServer(param) {
    let queryString = "";
    if (param.searchdata) {
      queryString = "?searchdata=" + param.searchdata;
    }
    return axiosInstance.get(getMiddlewareFile("server", api_endpoint_prefix) + queryString, {
      headers: authHeader("server", api_endpoint_prefix),
    });
  }

  storeServer(ServerData) {
    const form = new FormData();
    for (var key in ServerData) {
      form.append(key, ServerData[key]);
    }
    return axiosInstance
    .post(postMiddlewareFile("server", api_endpoint_prefix), form, {
      headers: authHeader("server", api_endpoint_prefix),
    })
    .then((response) => {
      return response.data;
    });
  }

  updateServer(ServerData) {
    const form = new FormData();
    form.append("id", ServerData.edit_id);
    form.append("name", ServerData.edit_name);
    form.append("ip", ServerData.edit_ip);
    form.append("bg_color", ServerData.edit_bg_color);
    form.append("platform", ServerData.edit_platform);
    form.append("vpn_server_name", ServerData.edit_vpn_server_name);
    form.append("type", ServerData.edit_type);
    form.append("status", ServerData.edit_status);
    return axiosInstance
      .post(updateMiddlewareFile("server", api_endpoint_prefix), form, {
        headers: authHeader("server", api_endpoint_prefix),
      })
      .then((response) => {
        return response.data;
      });
  }

  deleteServer(ServerData) {
      const form = new FormData();
      form.append("id", ServerData.edit_id);
      return axiosInstance
        .post(deleteMiddlewareFile("server", api_endpoint_prefix), form, {
          headers: authHeader("server", api_endpoint_prefix),
        })
        .then((response) => {
          return response.data;
        });
  }

  getNotification() {
    return axiosInstance.get(getMiddlewareFile("notification", api_endpoint_prefix), {
      headers: authHeader("notification", api_endpoint_prefix),
    });
  }

  updateNotifyStatus(notifyData) {
    const form = new FormData();
    form.append("is_read", 1);
    form.append("id", notifyData.id);
    return axiosInstance
      .post(updateMiddlewareFile("notification", api_endpoint_prefix), form, {
        headers: authHeader("notification", api_endpoint_prefix),
      })
      .then((response) => {
        return response.data;
      });
  }
  
  getPackage() {
    return axiosInstance.get(getMiddlewareFile("packages", api_endpoint_prefix), {
      headers: authHeader("packages", api_endpoint_prefix),
    });
  }

  getApiRefreshToken() {
    return axiosInstance.get(getMiddlewareFile("refresh-token", api_endpoint_prefix), {
      headers: authHeader("refresh-token", api_endpoint_prefix),
    });
  }

  verifyJwtToken() {
    return axiosInstance.get(getMiddlewareFile("verify-token", api_endpoint_prefix), {
      headers: authHeader("verify-token", api_endpoint_prefix),
    });
  }

}

export default new ClientService();
